module.exports = "<!-- <big-title-finance></big-title-finance> -->\n<span style='display:block;font-size:30px;padding:20px 0px;'>Finance</span>\n<app-finance-menu></app-finance-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance.component.html
// module id = ./src/app/finance/finance.component.html
// module chunks = main